import { content } from '@/app/gridGL/pixiApp/contentInstance';

export const isHtmlChartTable = (tableName: string | undefined): boolean => {
  if (!tableName) return false;
  return !!content.cellsSheet.tables.getTableFromName(tableName)?.codeCell.is_html;
};
